export const getHasFirmedChangeByMotive = ({ target: { value } }) => ({
  target: { name: 'hasFirmed', value: value === '06' ? '' : 0 },
});
